import { selectBaseAuctionBetByServiceId, selectCurrentBet } from '../auction';
import { IAppState } from './../../types/reducers/state';
import { selectActiveServiceIdIfEnabled } from './selectActiveServiceIdIfEnabled';

// Возвращает цену выбранного сервиса
export const selectDynamicPrice = (state: IAppState) => {
  const serviceId = selectActiveServiceIdIfEnabled(state);

  if (!serviceId) {
    return;
  }

  const baseAuctionPrice = selectBaseAuctionBetByServiceId(serviceId, state);

  if (serviceId === 'top3') {
    const currentBet = selectCurrentBet(state);

    return Math.max(baseAuctionPrice, currentBet);
  }

  return baseAuctionPrice;
};
